import Button from "./Button";

export const ExtendDealsConfirmButton = ({ onClick }) => {
  return (
    <Button
      type="primary"
      label="Confirm"
      size="small"
      disabled={false}
      loading={false}
      stretch={true}
      center={true}
      onClick={onClick}
    />
  );
};
